import React, { Component } from 'react';
import { Card, Checkbox, Col, Form, Input, Row, Select, Modal, InputNumber } from 'antd';
import { inject, observer } from 'mobx-react';
const Option = Select.Option;

@inject('store')
@observer
export class BaseForm extends Component {
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        const type = getFieldValue('type');

        return (
            <Card title={this.props.title} bordered={false} style={{ marginBottom: 15 }}>
                <Row gutter={24}>
                    <Col md={24}>
                        <Form.Item label="Type">
                            {getFieldDecorator('type', {
                                rules: [{ required: true, message: 'Type is required' }],
                                onChange: value => {
                                    if (!this.props.edit) return;

                                    let buySource = 'buy';
                                    let sellSource = 'sell';
                                    let buyDest = 'buy';
                                    let sellDest = 'sell';

                                    switch (this.props.initialData.type) {
                                        case 'art':
                                            buySource = 'rt_buy';
                                            sellSource = 'rt_final_sell';
                                            break;
                                        case 'adca':
                                            buySource = 'dca_buy';
                                            sellSource = 'dca_sell';
                                            break;
                                        default:
                                            buySource = 'buy';
                                            sellSource = 'sell';
                                    }

                                    switch (value) {
                                        case 'art':
                                            buyDest = 'buy';
                                            sellDest = 'rt_final_sell';
                                            break;
                                        case 'adca':
                                            buyDest = 'dca_buy';
                                            sellDest = 'dca_sell';
                                            break;
                                        default:
                                            buyDest = 'buy';
                                            sellDest = 'sell';
                                    }
                                    let next = { ...this.props.initialData };

                                    if (buySource !== sellDest) {
                                        const config = this.props.store.botStore.usedStrats[
                                            next.id
                                        ];

                                        if (config) {
                                            Modal.error({
                                                title: 'Strategy assigned to bot ' + config.name,
                                                content:
                                                    'Ensure this strategy is not actively being used by the bot'
                                            });
                                            return;
                                        }
                                    }

                                    next[sellDest] = next[sellSource];
                                    next[buyDest] = next[buySource];
                                    delete next[buySource];
                                    delete next[sellSource];
                                    next.type = value;

                                    Modal.confirm({
                                        title: 'Migrate strategy type?',
                                        content: `Strategy will be migrated to (${value}) and the record saved`,
                                        onOk: () => {
                                            this.props.store.strategyStore.update(next.id, next);
                                        }
                                    });
                                }
                            })(
                                <Select>
                                    <Option value="buy_sell">Buy/Sell</Option>
                                    <Option value="trigger">Automation</Option>
                                    <Option value="adca">Auto DCA</Option>
                                    <Option value="art">Auto Reverse Trading</Option>
                                    <Option value="signal">Signal</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={24}>
                        <Form.Item label="Name">
                            {getFieldDecorator('name', {
                                rules: [{ required: true, message: 'Name is required' }]
                            })(<Input />)}
                        </Form.Item>
                    </Col>

                    <Col md={24}>
                        <Form.Item label="Description">
                            {getFieldDecorator('description', {
                                initialValue: ''
                            })(<Input.TextArea rows={5} />)}
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item label="Candle style">
                            {getFieldDecorator('candle_style', {
                                initialValue: 'standard'
                            })(
                                <Select>
                                    <Option value="standard">Standard</Option>
                                    <Option value="heikin_ashi">Heikin Ashi</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item label="Scan Time">
                            {getFieldDecorator('scan_time', {
                                initialValue: 'realtime'
                            })(
                                <Select>
                                    <Option value="realtime">Realtime</Option>
                                    <Option value="30">30 Seconds</Option>
                                    <Option value="60">60 Seconds</Option>
                                    <Option value="120">2 Minutes</Option>
                                    <Option value="300">5 Minutes</Option>
                                    <Option value="900">15 Minutes</Option>
                                    <Option value="1800">30 Minutes</Option>
                                    <Option value="3600">1 Hour</Option>
                                    <Option value="candle_close">Candle Close</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    {type === 'art' ? (
                        <Col md={6} style={{ paddingLeft: 12, paddingRight: 12 }}>
                            <Form.Item label="Max ART Levels">
                                {getFieldDecorator(`max_levels`, {
                                    rules: [{ required: true, message: 'Field is required' }],
                                    initialValue: 5
                                })(<InputNumber />)}
                            </Form.Item>
                        </Col>
                    ) : null}
                    {type === 'buy_sell' || type === 'signal' ? (
                        <Col md={6}>
                            <Form.Item
                                label="Enable Auto DCA"
                                extra="Auto DCA will monitor positions."
                            >
                                {getFieldDecorator('auto_dca_enabled', {
                                    valuePropName: 'checked',
                                    initialValue: true
                                })(<Checkbox>Yes</Checkbox>)}
                            </Form.Item>
                        </Col>
                    ) : null}

                    {type === 'buy_sell' || type === 'signal' ? (
                        <Col md={6}>
                            <Form.Item
                                label="Enable Auto RT"
                                extra="Auto RT will monitor positions."
                            >
                                {getFieldDecorator('auto_reverse_enabled', {
                                    valuePropName: 'checked',
                                    initialValue: true
                                })(<Checkbox>Yes</Checkbox>)}
                            </Form.Item>
                        </Col>
                    ) : null}
                </Row>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/Standard/Shared/Base.js